import { render, staticRenderFns } from "./optLog.vue?vue&type=template&id=a495300e"
import script from "./optLog.vue?vue&type=script&lang=js"
export * from "./optLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports